import * as SystemActions from './../../system/actions/system.actions';
import * as GeneralSelectionActions from '../actions/general-selection.actions';
import { initialGeneralSelectionState, IGeneralSelectionState } from '../../state/general-selection.state';

export function GeneralSelectionReducer(state = initialGeneralSelectionState, action: GeneralSelectionActions.GeneralSelectionActions | SystemActions.SystemActions): IGeneralSelectionState {
  // TODO: We could probably consolidate most of these actions into a single 'update' action.
  switch (action.type) {
        case GeneralSelectionActions.UPDATE_DATE:
            return {
                ...state,
                toDate: action.payload
            };
        case GeneralSelectionActions.UPDATE_SELECTION:
            return {
                ...state,
                toDate: action.payload.toDate,
                selectedEntities: [
                    ...action.payload.selectedEntities
                ],
                selectedClient: action.payload.selectedClient,
                selectedPortfolios: action.payload.selectedPortfolios ? [...action.payload.selectedPortfolios] : [],
            };
        case GeneralSelectionActions.UPDATE_DATE_SELECTION:
            return {
                ...state,
                fromDate: action.payload.fromDate,
                toDate: action.payload.toDate,
            };
        case GeneralSelectionActions.UPDATE_SELECTED_PORTFOLIOS:
            return {
                ...state,
                fromDate: action.payload.fromDate,
                toDate: action.payload.toDate,
                selectedPortfolios: action.payload.selectedPortfolios
            };
        case GeneralSelectionActions.UPDATE_BASE_URL:
            return {
                ...state,
                baseUrl: action.payload
            };
        case GeneralSelectionActions.SET_CLIENT_DATA_INITIALISED:
            return {
                ...state,
                dataInitalised: true
            };
        case GeneralSelectionActions.UPDATE_CURRENCY:
            return {
                ...state,
                selectedCurrency: action.payload
            };
        case GeneralSelectionActions.UPDATE_CLIENT_TITLE:
            return {
                ...state,
                clientTitle: action.payload
            };
        case SystemActions.CLEAR_SYSTEM:
            return initialGeneralSelectionState;
        default:
            return state;
    }
}
